import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import Order from "../../api/orderApi";
import { UserLogout } from "../../appRedux/action/OrderAction";
import { getStoragePersist } from "../../constants";

function SupportScreen(props) {
  const [isLogin, setIsLogin] = useState(false);
  const history = useHistory();
  const userTemp = useSelector((x) => x?.auth?.user?.user?.id);
  const temp = useSelector((x) => x.auth.isLogin);

  // console.log(userTemp);
  const dispatch = useDispatch();

  const handleLogout = async () => {
    await dispatch(UserLogout());
    history.replace("/login");
  };

  return (
    <div className="support__screen">
      <h1 className="content__title mb-3">Hỗ trợ</h1>

      {temp && (
        <Link to={`/register/${userTemp ? userTemp : null}`}>
          <button className="w-100 btn">Thông tin cá nhân</button>
        </Link>
      )}

      <Link to="/register-vaccine">
        <button className="w-100 btn">Đăng kí thông tin tiêm chủng</button>
      </Link>
      <Link to="/manage-register">
        <button className="w-100 btn"> Danh sách đăng ký tiêm chủng</button>
      </Link>
      {/* <Link to="/register-vaccine">
        <button className="w-100 btn">Câu hỏi thường gặp</button>
      </Link> */}

      {!temp && (
        <>
          <Link to="/login">
            <button className="w-100 btn">Đăng nhập</button>
          </Link>
          <Link to="/register">
            <button className="w-100 btn">Đăng kí</button>
          </Link>
        </>
      )}

      {temp && (
        <button className="w-100 btn" onClick={handleLogout}>
          Đăng xuất
        </button>
      )}
    </div>
  );
}

export default SupportScreen;
